import { TemplateEngine } from "../shared/utils/TemplateEngine.js";
import { VacacionesService } from "../shared/services/VacacionesService.js";
import { SesionService } from "../shared/services/SesionService.js";
import { Layout } from "../shared/components/navbar/Navbar.js";
import { Loading } from "../shared/components/Loading.js";
import accesoTemplate from "./templates/acceso.html?raw";

const MSG_INVALIDO = "No encontramos datos con ese legajo y DNI. Revisá que estén bien escritos; si el problema sigue, avisá a RRHH.";
const MSG_ERROR = "No pudimos validar tus datos. Intentá de nuevo en unos minutos; si sigue así, avisá a Sistemas.";

export const AccesoController = {
  // Mensaje a mostrar en el proximo render (lo deja el ingreso directo cuando falla).
  mensajePendiente: "",

  render() {
    SesionService.cerrar();

    const contenido = TemplateEngine.render(accesoTemplate, {
      mensaje: AccesoController.mensajePendiente,
      legajo: "",
      dni: "",
    });
    AccesoController.mensajePendiente = "";
    Layout.render(contenido);

    document.getElementById("formAcceso").addEventListener("submit", AccesoController.onSubmit);
    document.getElementById("txtLegajo").focus();
  },

  async onSubmit(e) {
    e.preventDefault();
    const legajo = document.getElementById("txtLegajo").value.trim();
    const dni = document.getElementById("txtDni").value.trim();

    if (!/^\d+$/.test(legajo) || !/^\d+$/.test(dni)) {
      AccesoController.mostrarMensaje("Completá legajo y DNI, solo con números.");
      return;
    }

    const btn = document.getElementById("btnContinuar");
    btn.disabled = true;
    Loading.mostrar();
    try {
      const ok = await AccesoController.validar(legajo, dni);
      if (ok) {
        window.location.hash = "vacaciones";
        return;
      }
      AccesoController.mostrarMensaje(AccesoController.mensajePendiente);
      AccesoController.mensajePendiente = "";
    } finally {
      btn.disabled = false;
      Loading.ocultar();
    }
  },

  /**
   * Ingreso directo por URL (lo llama main.js antes de iniciar el router).
   * Devuelve true si quedo la sesion iniciada.
   */
  async ingresoDirecto({ legajo, dni }) {
    Loading.mostrar();
    try {
      return await AccesoController.validar(legajo, dni);
    } finally {
      Loading.ocultar();
    }
  },

  // Valida contra la API. Si es valido inicia la sesion; si no, deja el mensaje en mensajePendiente.
  async validar(legajo, dni) {
    try {
      const resultado = await VacacionesService.validarEmpleado(legajo, dni);
      if (resultado.valido) {
        SesionService.iniciar(resultado.empleado);
        return true;
      }
      AccesoController.mensajePendiente = MSG_INVALIDO;
    } catch (error) {
      console.error("Error validando empleado:", error);
      AccesoController.mensajePendiente = MSG_ERROR;
    }
    return false;
  },

  mostrarMensaje(texto) {
    const el = document.getElementById("msgAcceso");
    if (!el) return;
    el.textContent = texto;
    el.hidden = !texto;
  },
};
